import { render, staticRenderFns } from "./CancelHistory.vue?vue&type=template&id=fbb46fe8&scoped=true&"
import script from "./CancelHistory.vue?vue&type=script&lang=js&"
export * from "./CancelHistory.vue?vue&type=script&lang=js&"
import style0 from "./CancelHistory.vue?vue&type=style&index=0&id=fbb46fe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb46fe8",
  null
  
)

export default component.exports